import { render, staticRenderFns } from "./AskManage.vue?vue&type=template&id=30999544&"
import script from "./AskManage.vue?vue&type=script&lang=js&"
export * from "./AskManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports